<div [style.height.px]="height" class="content" data-cy="spinner.component">
  <gcv-spinner-icon></gcv-spinner-icon>
</div>
